import {mapActions} from 'vuex'

export const columnSettingMixin = {
  data: () => {
    return {
      dynamicColumns: [],
    }
  },
  methods: {
    ...mapActions('common/gridSetting', [
      'fetchGridSettingsByCode',
      'saveGridSetting',
    ]),
    mapColumnSettings({columnSettings}) {
      return columnSettings.map((column) => {
        return {
          columnProperty: column.value,
          isVisibleForUser: column.isVisibleForUser,
          width: column.width ? column.width : null
        }
      })
    },
    async initializeVisibleHeaders(
      dynamicColumns,
      gridCode,
      prependedColumns = null,
      appendedColumns = null
    ) {
      await this.$nextTick(async () => {
        this.dynamicColumns = [...dynamicColumns]
        const gridSettings = await this.fetchGridSettingsByCode(gridCode)
        if (!gridSettings.columnSettings) {
          gridSettings.columnSettings = this.mapColumnSettings({
            columnSettings: this.dynamicColumns,
          })
          gridSettings.gridCode = gridCode
          await this.saveGridSetting({gridSettings})
        }

        // Set user settings
        for (const i in this.dynamicColumns) {
          for (const j in gridSettings.columnSettings) {
            if (
              this.dynamicColumns[i].value ===
              gridSettings.columnSettings[j].columnProperty
            ) {
              this.dynamicColumns[i].isVisibleForUser =
                gridSettings.columnSettings[j].isVisibleForUser
              if(gridSettings.columnSettings[j].width) {
                this.dynamicColumns[i].width = gridSettings.columnSettings[j].width
              }
              break
            }
          }
        }
        //check if any dynamic columns are missing from the gridsettings' columnsettings
        for(const dc of this.dynamicColumns) {
          const cSetting = gridSettings.columnSettings.find(cs=> cs.columnProperty === dc.value)
          if(!cSetting) {
            gridSettings.columnSettings.push(
              {
                columnProperty: dc.value,
                isVisibleForUser: true,
                width: null
              }
            )
            await this.saveGridSetting({gridSettings})
          }
        }

        let visibleHeaders = [
          ...this.dynamicColumns.filter((column) => column.isVisibleForUser),
        ]
        if (prependedColumns) {
          prependedColumns.forEach((element) => {
            visibleHeaders.unshift(element)
          })
        }

        if (appendedColumns) {
          visibleHeaders = [...visibleHeaders, ...appendedColumns]
        }
        this.headers = visibleHeaders
      })
    },
    getDynamicColumns(fieldSettingCode, align = 'center', width = null) {
      return this.$store.state.backoffice.settings.fields[fieldSettingCode]
        .filter((field) => field.isVisible)
        .map((field) => {
          return {
            text: field.displayText,
            value: field.fieldName,
            sortable: false,
            align: align,
            isVisibleInList: field.isVisibleInList,
            controlType: field.fieldType,
            fieldType: 'FIELD_SETTING',
            isVisibleForUser: true,
            isFilter: field.isFilter,
            Rank:field.rank,
            width: width,
          }
        })
        .sort((a,b)=>this.sortByRank(a,b))
    },
    sortByRank(a,b) {
      if (a.Rank === null && b.Rank === null) {
        return 0;
      } else if (a.Rank === null) {
        return 1;
      } else if (b.Rank === null) {
        return -1;
      } else {
        return a.Rank - b.Rank;
      }
    }
  },
}
